<template>
  <fieldset v-if="withredirect"  class="theme-switcher-ellips theme-switcher" data-fade-in-left>


    <input v-for="(theme, index) in themeColor" :key = "index" :class="['theme-switcher__radio', theme.class, section === 'recipes'? theme.classForRecipes : '']"
           data-theme
           type="radio"
           name="color-scheme"
           :value="theme.color"
           :aria-label="theme.area"
           @click = "getThemeAndRedirect(theme.color)"
           :checked="theme.checked"
           v-on:click.self.prevent
    >



  </fieldset>

  <fieldset v-else-if ="displaynone" style="display: none" class="theme-switcher-ellips theme-switcher" data-fade-in-left>


    <input v-for="(theme, index) in themeColor" :key = "index" :class="['theme-switcher__radio', theme.class]"
           data-theme
           type="radio"
           name="color-scheme"
           :value="theme.color"
           :aria-label="theme.area"

           :checked="theme.checked"
    >


  </fieldset>

  <fieldset v-else  class="theme-switcher-ellips theme-switcher" data-fade-in-left>

    <input v-for="(theme, index) in themeColor" :key = "index" :class="['theme-switcher__radio', theme.class]"
           data-theme
           type="radio"
           name="color-scheme"
           :value="theme.color"
           :aria-label="theme.area"
           @click = "getTheme(theme.color)"
           :checked="theme.checked"
    >
  </fieldset>
</template>

<script>
export default {
  data()
    {
      return {
        themeColor :
            [
              {
                color : "brown",
                area  : "коричневая",
                class: "theme-switcher__radio_brown",
                classForRecipes: "theme-switcher__radio_recipes-barista",
                checked: true,


              },
              {
                color : "green",
                area  : "зеленая",
                class: "theme-switcher__radio_green",
                classForRecipes: "theme-switcher__radio_recipes-gm",
                checked : false,


              }

            ],
        currentTheme: localStorage.getItem('color-scheme'),

      };
    },
  props: {
    displaynone: {
      type: Boolean
    },
    withredirect: {
      type: Boolean
    },
    section: {
      default: "",
      type: String,
      required: false
    }

  },
  name    : "SwitcherThemeEllipse",

  methods : {
    getTheme(color)
      {

        this.currentTheme = color;
        this.$emit('change-theme', color);

      },
    getThemeAndRedirect(color)
      {
          window.location.href = "/"+ this.section + "/"+color+"/";
          this.currentTheme = color;
          this.$emit('change-theme', color);

      },
    // mounted() {
    //   console.log('mounted vue');
    //   window.initUI();
    //
    // },


  },
  mounted()
    {
      //console.log(window.location.pathname.split('/')[2]);
      if(window.location.pathname.split('/')[2] && window.location.pathname.split('/')[2] !== this.currentTheme){
        //this.$emit('change-theme', window.location.pathname.split('/')[2]);
        localStorage.setItem('color-scheme', window.location.pathname.split('/')[2]);
        document.cookie = "theme="+ window.location.pathname.split('/')[2] + "; path=/; max-age=86400;";
      }
    },
};
</script>

<style scoped>

</style>